<template>
  <div>
    <forgot-password />
  </div>
</template>
<script>
import ForgotPassword from "@/components/accounts/forgotPassword";
export default {
  components: {
    ForgotPassword
  }
};
</script>
